import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import AddOpcionModal from '../components/AddOpcionModal'; // Importa el nuevo componente
import { useSnackbar } from 'notistack';
import DeleteIcon from '@mui/icons-material/Delete'; // <-- ¡Asegúrate de que esta línea esté presente!
import ConfirmDeleteDialog from '../components/ConfirmDeleteDialog '; // ¡Importa el nuevo componente!



import {
  Box,
  Typography,
  Button,
  TextField,
  CircularProgress,
  Alert,
  Paper, // Usamos Paper para un contenedor con elevación
  Grid,
  Container,
  IconButton,
  Checkbox
} from '@mui/material';

function AdminPage() {
  const { user } = useAuth();
  const [opcionesPrecios, setOpcionesPrecios] = useState([]);
  const [newPrices, setNewPrices] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [tiposReservaBase, setTiposReservaBase] = useState([]);
  const [newTiposReservasPrices, setNewTiposReservaPrices] = useState({});
  const [openModal, setOpenModal] = useState(false); // Estado para el modal
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [opcionToDelete, setOpcionToDelete] = useState(null);
  const { enqueueSnackbar } = useSnackbar();




  const [resetUserId, setResetUserId] = useState('');
  const [resetNewPassword, setResetNewPassword] = useState('');
  const [resetError, setResetError] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const { adminResetPassword } = useAuth();

  const [reglamentoFile, setReglamentoFile] = useState(null);
  const [infoFile, setInfoFile] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Fetch opciones y reservas al cargar
  // En tu componente AdminPage.js

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  useEffect(() => {
    const fetchAdminData = async () => {
      setLoading(true);
      setError('');
      try {
        // 1. Lanzamos ambas llamadas a la API en paralelo
        const [opcionesRes, tiposReservaRes] = await Promise.all([
          api.get('/Reservas/opciones'),
          api.get('/Reservas/tipos-reserva') // <-- Nueva llamada al endpoint
        ]);

        // 2. Procesamos los datos de opciones adicionales
        setOpcionesPrecios(opcionesRes.data);
        const initialNewPrices = {};
        opcionesRes.data.forEach(op => {
          initialNewPrices[op.id] = op.precio;
        });
        setNewPrices(initialNewPrices);

        // 3. Procesamos los datos de tipos de reserva base
        setTiposReservaBase(tiposReservaRes.data);
        const initialTiposReservaPrices = {};
        tiposReservaRes.data.forEach(tipo => {
          initialTiposReservaPrices[tipo.id] = tipo.precio;
        });
        setNewTiposReservaPrices(initialTiposReservaPrices);

      } catch (err) {
        console.error('Error fetching admin data:', err.response?.data || err);
        setError('Error al cargar datos del administrador.');
      } finally {
        setLoading(false);
      }
    };

    if (user?.isAdmin) {
      fetchAdminData();
    }
  }, [user]);

  const handleHabilitarToggle = (id) => {
    setOpcionesPrecios(prevOpciones =>
      prevOpciones.map(opcion =>
        opcion.id === id ? { ...opcion, habilitada: !opcion.habilitada } : opcion
      )
    );
  };

  const handlePriceChange = (id, value) => {
    setNewPrices(prev => ({
      ...prev,
      [id]: parseFloat(value) || 0
    }));
  };

  const handlePriceChangeReservas = (id, value) => {
    setNewTiposReservaPrices(prev => ({
      ...prev,
      [id]: parseFloat(value) || 0
    }));
  };

  const handleDeleteOpcion = (opcion) => {
    setOpcionToDelete(opcion);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!opcionToDelete) return;

    setLoading(true);
    setDeleteDialogOpen(false); // Cierra el diálogo
    try {
      await api.delete(`/Reservas/admin/eliminarOpcion/${opcionToDelete.id}`);

      // Actualizamos el estado local para eliminar la opción de la UI
      setOpcionesPrecios(prevOpciones => prevOpciones.filter(op => op.id !== opcionToDelete.id));

      enqueueSnackbar('Opción eliminada exitosamente.', { variant: 'success' });

      // Limpiamos los estados de eliminación
      setOpcionToDelete(null);

    } catch (err) {
      console.error('Error al eliminar la opción:', err);
      enqueueSnackbar(err.response?.data?.message || 'Error al eliminar la opción.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // Handler para cerrar el diálogo sin eliminar
  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setOpcionToDelete(null);
  };

  const handleUpdatePrices = async () => {
    setLoading(true);
    setError('');
    setMessage('');

    try {
      // 1. Crear la lista completa de actualizaciones
      const updates = opcionesPrecios.map(opcion => ({
        id: opcion.id,
        precio: newPrices[opcion.id] !== undefined ? newPrices[opcion.id] : opcion.precio,
        habilitada: opcion.habilitada,
      }));

      // 2. Iterar sobre cada actualización y enviar una solicitud PUT individual
      for (const update of updates) {
        await api.put('/Reservas/admin/precios', update);
      }

      enqueueSnackbar('Opciones adicionales actualizadas correctamente', { variant: 'success' });

      // 3. Recargar los datos después de todas las actualizaciones
      const opcionesRes = await api.get('/Reservas/opciones');
      setOpcionesPrecios(opcionesRes.data);

    } catch (err) {
      console.error('Error al actualizar opciones adicionales:', err.response?.data || err);
      enqueueSnackbar('Error al actualizar los precios', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePricesReservas = async () => {
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const updatesTipo = Object.keys(newTiposReservasPrices).map(id => ({
        id: parseInt(id),
        precio: newTiposReservasPrices[id]
      }));

      for (const updateTipo of updatesTipo) {
        await api.put('/Reservas/admin/precioTipoReserva', updateTipo);
      }
      enqueueSnackbar('Precios de reservas actualizados correctamente', { variant: 'success' });
      setLoading(false);
      // Opcional: Refrescar opciones desde la API si la actualización no devuelve los datos
      const TiposRes = await api.get('/Reservas/tipos-reserva');
      setTiposReservaBase(TiposRes.data);

    } catch (err) {
      console.error('Error updating prices:', err.response?.data || err);
      enqueueSnackbar('Error al actualizar los precios', { variant: 'error' });
      setLoading(false);
    }
  };


  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetError('');
    setResetMessage('');

    if (!resetUserId || !resetNewPassword) {
      setResetError("ID de usuario y nueva contraseña son requeridos.");
      return;
    }

    // --- Validación de la longitud de la contraseña ---
    if (resetNewPassword.length < 6) {
      setResetError("La nueva contraseña debe tener por lo menos 6 caracteres.");
      return;
    }

    const result = await adminResetPassword(resetUserId, resetNewPassword);
    if (result.success) {
      enqueueSnackbar('Contraseña actualizada correctamente', { variant: 'success' });
      setResetUserId('');
      setResetNewPassword('');
    } else {
      enqueueSnackbar('Error al actualizar la contraseña', { variant: 'error' });
      setResetError(result.message);
    }
  };

  const handleAddOpcion = async (nuevaOpcion) => {
    setLoading(true);
    try {
      // Llama a tu nuevo endpoint POST para agregar la opción
      const response = await api.post('/Reservas/agregarOpcionAdicional', nuevaOpcion);
      const addedOpcion = response.data.opcion; // La API debería devolver la nueva opción con su ID

      setOpcionesPrecios(prevOpciones => [...prevOpciones, addedOpcion]);

      setNewPrices(prevPrices => ({
        ...prevPrices,
        [addedOpcion.id]: addedOpcion.precio // Usamos el ID de la API
      }));

      enqueueSnackbar('Opción agregada exitosamente.', { variant: 'success' });
      // Recarga los datos para que la nueva opción aparezca en la lista


    } catch (err) {
      console.error('Error al agregar la opción:', err);
      enqueueSnackbar(err.response?.data?.message || 'Error al agregar la opción.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleReglamentoFileChange = (event) => {
    setReglamentoFile(event.target.files[0]);
  };

  const handleInfoFileChange = (event) => {
    setInfoFile(event.target.files[0]);
  };
  const handleUploadReglamento = async () => {
    if (!reglamentoFile) {
      setErrorMessage('Por favor seleccione un archivo PDF.');
      return;
    }

    const formData = new FormData();
    formData.append('file', reglamentoFile);

    try {
      await api.post('/Reservas/upload-pdf', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setSuccessMessage('PDF subido correctamente.');
      setReglamentoFile(null); // Limpia selección
      enqueueSnackbar('PDF subido correctamente', { variant: 'success' });

    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error al subir el PDF', { variant: 'error' });
      setErrorMessage('Error al subir el PDF.');
    }
  };

  const handleUploadInfo = async () => {
    if (!infoFile) {
      setErrorMessage('Por favor seleccione un archivo PDF.');
      return;
    }

    const formData = new FormData();
    formData.append('file', infoFile);

    try {
      await api.post('/Reservas/upload-Info', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setSuccessMessage('PDF subido correctamente.');
      setInfoFile(null); // Limpia selección
      enqueueSnackbar('PDF subido correctamente', { variant: 'success' });

    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error al subir el PDF', { variant: 'error' });
      setErrorMessage('Error al subir el PDF.');
    }
  };


  if (!user?.isAdmin) {
    return <div className="text-center mt-8 text-red-500">Acceso denegado. Solo para administradores.</div>;
  }


  return (

    <Container color="red" maxWidth="md" sx={{ mt: 4, mb: 6 }}> {/* Ajusta el ancho y márgenes */}
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 4, color: 'text.primary' }}>
        Panel de Administración
      </Typography>

      {/* Componente de Gestión de Precios */}
      <Box sx={{ my: 4 }}> {/* Agrega margen vertical */}
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}> {/* Paper para el contenedor principal */}
          <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main', mb: 3 }}>
            Gestión de precios de las reservas
          </Typography>

          {loading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>Cargando precios...</Typography>
            </Box>
          )}

          {!loading && !error && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2} direction="column">
                {tiposReservaBase.map(tipo => (
                  <Grid item key={tipo.id}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
                      <Typography variant="body1" sx={{ color: 'text.primary' }}>
                        {tipo.nombre}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>$</Typography>
                        <TextField
                          type="number"
                          step="0.01"
                          value={newTiposReservasPrices[tipo.id] !== undefined ? newTiposReservasPrices[tipo.id] : ''}
                          onChange={(e) => handlePriceChangeReservas(tipo.id, e.target.value)}
                          sx={{ width: 100, '& input': { textAlign: 'right' } }}
                          size="small"
                          variant="outlined"
                        />
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleUpdatePricesReservas}
                disabled={loading}
                sx={{ mt: 4, py: 1.5, px: 4 }}
              >
                {loading ? 'Guardando...' : 'Actualizar Precios'}
              </Button>
            </Box>
          )}
        </Paper>
      </Box>

      <Box sx={{ my: 4 }}> {/* Agrega margen vertical */}
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}> {/* Paper para el contenedor principal */}
          <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main', mb: 3 }}>
            Gestión de las opciones adicionales
          </Typography>

          {loading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>Cargando...</Typography>
            </Box>
          )}

          {!loading && !error && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2} direction="column">
                {opcionesPrecios.map(opcion => (
                  <Grid item key={opcion.id}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
                      <Typography variant="body1" sx={{ color: 'text.primary' }}>
                        {opcion.nombre} ({opcion.tipo})
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>$</Typography>
                        <TextField
                          type="number"
                          step="0.01"
                          value={newPrices[opcion.id] !== undefined ? newPrices[opcion.id] : ''}
                          onChange={(e) => handlePriceChange(opcion.id, e.target.value)}
                          sx={{ width: 100, '& input': { textAlign: 'right' } }}
                          size="small"
                          variant="outlined"
                        />
                        <Checkbox
                          checked={opcion.habilitada}
                          onChange={() => handleHabilitarToggle(opcion.id)}
                        />
                        <IconButton
                          aria-label="eliminar"
                          color="error"
                          onClick={() => handleDeleteOpcion(opcion)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>

                ))}
              </Grid>
              <ConfirmDeleteDialog
                open={deleteDialogOpen}
                title="Eliminar opcion"
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
                message={`¿Estás seguro de que quieres eliminar la opción "${opcionToDelete?.nombre}"? Esta accion es irreversible`}
              />
              <Box sx={{ display: 'flex', gap: 2, mt: 4 }}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleUpdatePrices}
                  disabled={loading}
                  sx={{ py: 1.5, px: 4 }}
                >
                  {loading ? 'Guardando...' : 'Actualizar'}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenModal}
                  sx={{ py: 1.5, px: 4 }}
                >
                  Agregar Opción
                </Button>
              </Box>
            </Box>
          )}
        </Paper>
      </Box>



      {/* Componente de Restablecimiento de Contraseña */}
      <Box sx={{ my: 4 }}> {/* Agrega margen vertical, puede ser solo mt si va después del anterior */}
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}> {/* Paper para el contenedor principal */}
          <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main', mb: 3 }}>
            Restablecer contraseña de usuario
          </Typography>

          <Box component="form" onSubmit={handleResetPassword}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="resetUserId"
              label="ID de Usuario (ej. Número de Apartamento)"
              value={resetUserId}
              onChange={(e) => setResetUserId(e.target.value)}
              placeholder="ID de usuario del residente"
              variant="outlined"
              sx={{ mb: 2 }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="resetNewPassword"
              label="Nueva Contraseña"
              type="password"
              value={resetNewPassword}
              onChange={(e) => setResetNewPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <Button
              type="submit"
              variant="contained"
              color="secondary" // Usamos color secundario para distinguirlo
              disabled={loading}
              sx={{ py: 1.5, px: 4 }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Restablecer Contraseña'}
            </Button>

            {resetError && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {resetError}
              </Alert>
            )}
            {resetMessage && (
              <Alert severity="success" sx={{ mt: 2 }}>
                {resetMessage}
              </Alert>
            )}
          </Box>
        </Paper>
      </Box>

      <Container sx={{ mt: 4, p: 3, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="h5" gutterBottom>Cambiar PDF del reglamento</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button variant="contained" component="label">
            Seleccionar PDF
            <input type="file" hidden accept="application/pdf" onChange={handleReglamentoFileChange} />
          </Button>

          {reglamentoFile && (
            <Typography variant="body2">Archivo seleccionado: {reglamentoFile.name}</Typography>
          )}

          <Button variant="contained" color="secondary" onClick={handleUploadReglamento}>
            Subir PDF
          </Button>
        </Box>

      </Container>

      <Container sx={{ mt: 4, p: 3, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="h5" gutterBottom>Cambiar PDF de Informacion</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button variant="contained" component="label">
            Seleccionar PDF
            <input type="file" hidden accept="application/pdf" onChange={handleInfoFileChange} />
          </Button>

          {infoFile && (
            <Typography variant="body2">Archivo seleccionado: {infoFile.name}</Typography>
          )}

          <Button variant="contained" color="secondary" onClick={handleUploadInfo}>
            Subir PDF
          </Button>
        </Box>

      </Container>
      <AddOpcionModal
        open={openModal}
        handleClose={handleCloseModal}
        handleAddOpcion={handleAddOpcion}
      />
    </Container>
  );
}
export default AdminPage;